module.exports = __webpack_public_path__ + "static/media/load-balancers-icon.8c96a365.svg";